import { Handle, NodeProps, Position } from 'reactflow';
import {
  SceneCanvasCharacterSelector,
  CharacterIcon,
  CharacterRole,
  CharacterOrientation,
} from '@evoach/ui-components';
import { useIntl } from 'react-intl';

import { useGlobalStyles, translateKey } from './base.node';
import { CustomNodeMenu } from './base.nodemenu';

/*
  CharacterSelector react-flow node for module builder graph canvas
*/

export const CharacterSelectorNode: React.FC<NodeProps<any>> = (
  nodeProps: any
) => {
  const classes = useGlobalStyles();
  const intl = useIntl();
  const payload = nodeProps.data.state.entry[0].payload;

  const dummyName = intl.formatMessage({
    id: 'builder.nodes.characterselector.node.dummyname',
    defaultMessage: 'Name des Characters (kommt aus Variable)',
  });

  const dummyElements = [
    {
      type: 'character',
      value: dummyName,
      name: dummyName,
      icon: CharacterIcon.DEFAULT,
      role: [CharacterRole.MEDIATOR],
      id: 'undefined',
      assetPath: 'undefined',
      position: { x: 5, y: 5 },
      width: 50,
      height: 50,
      ratio: 1,
      orientation: CharacterOrientation.ORIGINAL,
      statement: '',
    },
    {
      type: 'character',
      value: dummyName,
      name: dummyName,
      icon: CharacterIcon.DEFAULT,
      role: [CharacterRole.MEDIATOR],
      id: 'undefined',
      assetPath: 'undefined',
      position: { x: 5, y: 5 },
      width: 50,
      height: 50,
      ratio: 1,
      orientation: CharacterOrientation.ORIGINAL,
      statement: '',
    },
  ];

  return (
    <>
      <Handle
        type="target"
        id="messageinhandle"
        position={Position.Top}
        isConnectable={nodeProps.isConnectable}
        className={classes['react-flow__handle']}
      />
      <div
        className={nodeProps.selected ? classes.selectStyletrue : classes.root}
        style={{ width: '400px' }}
      >
        <CustomNodeMenu nodeid={nodeProps.id} />
        <SceneCanvasCharacterSelector
          saveResultTo={payload.saveResultTo}
          elements={dummyElements}
          buttonText={translateKey(intl, payload.buttonText)}
        />
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        id="messageouthandle"
        isConnectable={nodeProps.isConnectable}
        className={classes['react-flow__handle']}
      />
    </>
  );
};
